import { create } from 'zustand'

interface AccountStoreState {
  // `null` means the default selection — every active account, resolved from the accounts
  // query rather than stored. `[]` means the user deliberately deselected every account.
  //
  // The distinction is not cosmetic: under `null` an account created later is included
  // automatically, because the selection is derived rather than a snapshot of the ids that
  // happened to exist at boot. Matches the location and device stores (STATE-1).
  //
  // Resolve it with `useSelectedAccountIds`, and write it through `useAccountSelection` —
  // that action is also what collapses an explicit all-accounts selection back to `null`,
  // so the default state stays reachable from the UI.
  selectedAccountIds: string[] | null
}

interface AccountStoreActions {
  setSelectedAccountIds: (ids: string[] | null) => void
  reset: () => void
}

type AccountStore = AccountStoreState & AccountStoreActions

const initialState: AccountStoreState = {
  selectedAccountIds: null,
}

export const useAccountStore = create<AccountStore>()((set) => ({
  ...initialState,

  setSelectedAccountIds: (ids) => set({ selectedAccountIds: ids }),

  reset: () => set(initialState),
}))
